import React from 'react';
import LoadingCell from '../../Clinics/ClinicsList/components/Loaders/LoadingCell';
import { MasterMedicine } from '../../../apis/master-medicines/types';

interface MasterMedicinesTableRow {
  view: {
    name: string | JSX.Element;
  };
  ID?: string;
  route?: string;
  headers?: boolean;
}

export const headers: MasterMedicinesTableRow = {
  view: {
    name: 'Master medicine name'
  },
  headers: true
};

export const prepareLoadingData = (rowsPerPage: number) => {
  return Array.from({ length: rowsPerPage }).reduce<MasterMedicinesTableRow[]>(
    data => {
      data.push({
        view: {
          name: <LoadingCell />
        }
      });
      return data;
    },
    [headers]
  );
};

export const convertMasterMedicinesToTable = (data: MasterMedicine[]) => {
  if (!data) {
    return [];
  }

  return data.reduce(
    (data, item) => {
      const { _id, name } = item;

      data.push({
        view: {
          name,
        },
        ID: String(_id),
        route: 'clinics/master-medicines'
      });

      return data;
    },
    [headers]
  );
};
